<template>
  <!-- 修改员工备注 -->
  <el-dialog
    title="编辑员工备注"
    :visible.sync="visible"
    center
    :close-on-click-modal="false"
    width="554px"
    :before-close="handleClose">
    <el-alert
      class="alert"
      title
      type="info"
      :closable="false"
      show-icon
    >
      员工备注长度1-16位字符，只可以输入汉字、字母或数字，汉字算两个字符。
    </el-alert>
    <el-form label-width="100px" class="y-mt-20" :inline="false">
      <div class="view-content">
        <el-form-item label="员工备注">
          <el-input v-model="userNickName" style="width: 250px" placeholder="请输入员工备注"></el-input>
        </el-form-item>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose" plain>取 消</el-button>
      <el-button type="primary" @click="handleUpdate">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { setUserNickNameApi } from '@/api/baseInfo/staffManage/employeeMgr';
export default {
  props: ['showUpateDialog', 'curRowData'],
  data() {
    return {
      visible: false,
      userNickName: ''
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:showUpateDialog', false)
    },
    handleUpdate() {
      let reg = /^[\u4e00-\u9fa5a-zA-Z0-9]*$/; // 判断汉字、字母或数字
      let len = 0;
      // 一个汉字两个字符
      for (var i = 0; i < this.userNickName.length; i++) {
        var a = this.userNickName.charAt(i);
        if (a.match(/[^\x00-\xff]/ig) != null) {
          len += 2;
        } else {
          len += 1;
        }
      }
      if (!reg.test(this.userNickName) || len > 16) {
        this.$message.error('员工备注长度1-16位字符，只可以输入汉字、字母或数字，汉字算两个字符。');
        return;
      }
      let params = {
        userId: this.curRowData.userId,
        userNickName: this.userNickName
      }
      setUserNickNameApi(params).then(res => {
        if(res.success) {
          this.$message.success('设置成功');
          this.$set(this.curRowData, 'userNickName', this.userNickName);
          this.$emit('update:showUpateDialog', false)
        } else {
          this.$message.error(res.message || '设置失败')
        }
      }).catch(err => {
        this.$message.error('服务器错误');
      })
    }
  },
  watch: {
    showUpateDialog(val) {
      this.visible = val;
      this.userNickName = this.curRowData.userNickName;
    }
  }
}
</script>
